import React, { type ForwardedRef, forwardRef, type ReactNode } from 'react';

import { AnimatePresence } from 'framer-motion';

import { Background, type BackgroundProps, Credits, Hero, NftAsset, Section } from './components';

import { Content, Interior, StyledNftCard } from './styles';

export interface NftCardProps {
    children: ReactNode;
    tier?: BackgroundProps['tier'];
    compact?: boolean;
    noBackground?: boolean;
}

function NftCardComponent(
    { children, tier, compact = false, noBackground = false }: NftCardProps,
    ref: ForwardedRef<HTMLDivElement>,
) {
    const backgroundMarkup = noBackground ? null : <Background key="NftCard-Background" tier={tier} />;

    return (
        <StyledNftCard ref={ref} $compact={compact}>
            <AnimatePresence initial={false}>{backgroundMarkup}</AnimatePresence>

            <Interior>
                <Content>{children}</Content>
            </Interior>
        </StyledNftCard>
    );
}

// Passing generics to `forwardRef` to ensure `RefObject` only.
const NftCardForwarded = forwardRef<HTMLDivElement, NftCardProps>(NftCardComponent);

export const NftCard = Object.assign(NftCardForwarded, {
    Credits,
    Hero,
    NftAsset,
    Section,
});
